// src/components/scan/header/ScanHeaderDesktop.tsx
import { useTranslation } from 'react-i18next';

interface Props {
  domain: string;
  loading: boolean;
}

export default function ScanHeaderDesktop({ domain, loading }: Props) {
  const { t } = useTranslation();

  return (
    <div className="text-center mb-16">
      <h1 className="text-6xl font-extrabold mb-6 text-white">
        {t('scan.title')}
      </h1>
      <p className="text-2xl text-textLight max-w-5xl mx-auto">
        {loading ? `Realizando scan de ${domain}…` : t('scan.subtitle')}
      </p>
    </div>
  );
}
